// extracted by mini-css-extract-plugin
export default {"gpi":"GeoPlaceInput_gpi__bvTg2"};